import { render } from "./delivery-challans.vue?vue&type=template&id=b31d16c2"
import script from "./delivery-challans.vue?vue&type=script&lang=js"
export * from "./delivery-challans.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__